import { createSlice } from "@reduxjs/toolkit";
import { fetchVendorById, fetchVendorItems } from "./VendorThunks";

const initialState = {
  items: [],
  loading: false,
  error: null,
};

const vendorSlice = createSlice({
  name: "vendor",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchVendorItems.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchVendorItems.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload.data;
      })
      .addCase(fetchVendorItems.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(fetchVendorById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchVendorById.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedVendor = action.payload;
        // Store in localStorage
        try {
          localStorage.setItem(
            "vendor",
            JSON.stringify(action.payload)
          );
        } catch (e) {
          console.error("Failed to store selectedVendor in localStorage", e);
        }
      })
      .addCase(fetchVendorById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default vendorSlice.reducer;
